<template>
  <Modal
    :title="title"
    width="520"
    v-model="state"
    @on-visible-change="bindGetData"
    :mask-closable="false"
    class-name="vertical-center-modal"
  >
    <Spin size="large" fix v-if="loading"></Spin>
    <Row class="row-item">
      <Col span="6" class="col-item">
        <span class="item-field">媒体</span>
      </Col>
      <Col span="18" offset="1">
        <RadioGroup v-model="media" type="button">
          <Radio :label="10" :disabled="10 !== media">巨量引擎</Radio>
          <Radio :label="6" :disabled="6 !== media">超级汇川</Radio>
          <Radio :label="16" :disabled="16 !== media">腾讯</Radio>
          <Radio :label="45" :disabled="45 !== media">百度信息流</Radio>
        </RadioGroup>
      </Col>
    </Row>
    <Row class="row-item">
      <Col span="6" class="col-item">
        <span class="item-field">账号</span>
      </Col>
      <Col span="12" offset="1">
        <auto-complete
          v-model="account"
          :data="accountData"
          placeholder="请选择账号"
          @on-select="handleAccount"
          style="width: 250px"
        ></auto-complete>
      </Col>
    </Row>
    <Row class="row-item" v-if="group">
      <Col span="6" class="col-item">
        <span class="item-field">{{ routeName[0] }}</span>
      </Col>
      <Col span="12" offset="1">
        <auto-complete
          v-model="campaign"
          :data="campaignData"
          :placeholder="`请选择${routeName[0]}`"
          @on-select="handleCampaign"
          style="width: 250px"
        ></auto-complete>
      </Col>
    </Row>
    <Row class="row-item" v-if="plan">
      <Col span="6" class="col-item">
        <span class="item-field">{{ routeName[1] }}</span>
      </Col>
      <Col span="12" offset="1">
        <auto-complete
          v-model="adplan"
          :data="planData"
          :placeholder="`请选择${routeName[1]}`"
          @on-select="handlePlan"
          style="width: 250px"
        ></auto-complete>
      </Col>
    </Row>

    <Row slot="footer" :gutter="12">
      <Button type="default" @click="cancel">取消</Button>
      <Button type="primary" @click="save">确定</Button>
    </Row>
  </Modal>
</template>
<script>
import { adAccount } from '@/api/common.model'
import { queryGroupbyAccount, queryPlanbyAccount } from '@/api/convert.model'
import { setLocalInfo, isArray } from '@/common/js/utils'
import AutoComplete from '@/components/autocomplete/autocomplete.vue'
export default {
  name: 'openModal',
  components: { AutoComplete },
  props: {
    title: {
      type: String
    },
    value: {
      type: Boolean
    },
    media: {
      type: [Number, String]
    },
    group: {
      type: Boolean
    },
    plan: {
      type: Boolean
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    mediaHtml() {
      let name = ''
      if (this.media === 10) name = 'create/toutiao'
      else if (this.media === 6) name = 'create/uc'
      else if (this.media === 16) name = 'create/tencent'
      else if (this.media === 45) name = 'create/baidu'
      return name
    },
    mediaRoutes() {
      let route = []
      if (this.media === 10) route = ['group', 'plan', 'idea']
      else if (this.media === 6) route = ['plan', 'unit', 'idea']
      else if (this.media === 16) route = ['plan', 'unit', 'idea']
      else if (this.media === 45) route = ['plan', 'unit', 'idea']
      return route
    },
    routeName() {
      let name = []
      if (this.media === 10) name = ['计划组', '投放计划']
      else if (this.media === 6) name = ['计划组', '推广计划']
      else if (this.media === 16) name = ['推广计划', '计划']
      else if (this.media === 45) name = ['推广计划', '推广单元']
      return name
    }
  },
  methods: {
    bindGetData(val) {
      // 显示状态
      if (val) {
        if (!this.accuntStat) this.getAdAccount()
      } else {
        this.account = ''
        this.campaign = ''
        this.adplan = ''
      }
    },
    getAdAccount() {
      this.loading = true
      adAccount({
        mediaId: this.$store.state.Convert.media,
        authFlag: 1
      }).then((data) => {
        this.loading = false
        this.accuntStat = true
        if (data && isArray(data)) this.accountData = data
      })
    },
    getAdCampaign(id) {
      this.loading = true
      queryGroupbyAccount({
        adAccountId: id
      }).then((data) => {
        this.loading = false
        this.campaign = ''
        this.adplan = ''
        if (data && isArray(data)) {
          this.campaignData = data.map((ret) => {
            return {
              id: ret.adGroupId,
              name: ret.adGroupName
            }
          })
        }
      })
    },
    getAdPlan(id, campaginId) {
      this.loading = true
      queryPlanbyAccount({
        mediaId: this.media,
        campaginId: this.campaign
      }).then((data) => {
        this.loading = false
        this.adplan = ''
        if (data && isArray(data)) {
          this.planData = data.map((ret) => {
            return {
              id: ret.adId,
              name: ret.adName,
              plan: ret.planId
            }
          })
        }
      })
    },
    handleAccount(meta) {
      this.account = meta.id
      this.accountName = meta.name
      this.group && this.account && this.getAdCampaign(this.account)
    },
    handleCampaign(meta) {
      this.campaign = meta.id
      this.plan && this.account && this.campaign && this.getAdPlan(this.account, this.campaign)
    },
    handlePlan(meta) {
      this.adplan = meta.id
      this.planId = meta.plan || ''
    },
    save() {
      // 验证广告账号
      if (!this.account) {
        this.$Message.error({
          duration: 5,
          content: '未选择计划账号'
        })
        return
      }

      if (this.group) {
        // 广告创意新建
        if (this.plan) {
          if (!this.campaign) {
            this.$Message.error({
              duration: 5,
              content: `未选择${this.routeName[0]}`
            })
            return
          }
          if (!this.adplan) {
            this.$Message.error({
              duration: 5,
              content: `未选择${this.routeName[1]}`
            })
            return
          }
          this.cancel()
          window.open(`/${this.mediaHtml}/${this.mediaRoutes[2]}/${this.campaign}/${this.adplan}?plan=${this.planId}`, '_blank')
          return
        } else {
          // 投放计划新建
          if (!this.campaign) {
            this.$Message.error({
              duration: 5,
              content: `未选择${this.routeName[0]}`
            })
            return
          }
          this.cancel()
          window.open(`/${this.mediaHtml}/${this.mediaRoutes[1]}/${this.campaign}`, '_blank')
          return
        }
      }
      this.cancel()
      window.open(`/${this.mediaHtml}/${this.mediaRoutes[0]}`, '_blank')
    },
    cancel() {
      setLocalInfo(this.account, this.accountName, this.media)
      this.$emit('on-cancel')
    }
  },
  data() {
    return {
      loading: null,
      accuntStat: false,
      accountData: [], // 广告账号
      account: '',
      campaignData: [], // 广告组
      campaign: '',
      planData: [], // 投放计划
      adplan: '',
      planId: '' // 内部计划
    }
  }
}
</script>
